import { render, staticRenderFns } from "./order-modal-webcam.vue?vue&type=template&id=787d40a5&scoped=true"
import script from "./order-modal-webcam.vue?vue&type=script&lang=js"
export * from "./order-modal-webcam.vue?vue&type=script&lang=js"
import style0 from "./order-modal-webcam.vue?vue&type=style&index=0&id=787d40a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787d40a5",
  null
  
)

export default component.exports